/*
 * @Author: mercer
 * @Email: 13928932429@163.com
 * @Date: 2020-02-21 16:02:01
 * @LastEditTime : 2020-02-21 16:20:32
 * @Description: 时间过去多长时长判断
 */
import moment from 'moment'

export default function timeago(dateTimeStamp) {   //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
	let minute = 1000 * 60;
	let hour = minute * 60;
	let day = hour * 24;
	let month = day * 30;
	let now = new Date().getTime();
	let diffValue = now - moment(dateTimeStamp).valueOf();
	if (diffValue < 0) { return; }
	let monthC = diffValue / month;
	let weekC = diffValue / (7 * day);
	let dayC = diffValue / day;
	let hourC = diffValue / hour;
	let minC = diffValue / minute;
	let result;
	if (monthC >= 1) {
		result = "" + parseInt(monthC) + "个月前";
	}
	else if (weekC >= 1) {
		result = "" + parseInt(weekC) + "周前";
	}
	else if (dayC >= 1) {
		result = "" + parseInt(dayC) + "天前";
	}
	else if (hourC >= 1) {
		result = "" + parseInt(hourC) + "小时前";
	}
	else if (minC >= 1) {
		result = "" + parseInt(minC) + "分钟前";
	} else
		result = "刚刚";
	return result;
}



// WEBPACK FOOTER //
// ./src/utils/timeago.js